module.exports = __webpack_public_path__ + "img/chat-left-dots-fill.628aa1d4.svg";